// @vendors
import { useTranslation } from 'react-i18next';

// @utils
import { returnText, returnTextWithNumber } from './utils/Utils';

const DataProcessing = () => {
    const { t } = useTranslation();
    const classSubtitle = "w-full text-[15px] text-[#494949] font-semibold flex";

    return (
        <div className='w-full h-[100vh] flex flex-col items-center py-[40px] px-[20px] lg:px-[100px] bg-gray-100 gap-[30px] overflow-auto'>
            <div className="flex items-center space-x-3 rtl:space-x-reverse" >
                <span className="pl-6 xl:pl-4 text-textBrand text-center font-serif dark:text-dark-bgBrand text-[22px] xl:text-3xl font-bold leading-10 tracking-[5.50px] self-center whitespace-nowrap">
                    XERVIX
                </span>
            </div >
            <h3 className='w-full text-[18px] text-[#03314B] font-semibold flex justify-center '>
                {t("dataProcessing.title")}
            </h3>

            {returnText(t("dataProcessing.paragraph1"))}
            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    1. {t("dataProcessing.numeral1.title")}
                </h5>
                {returnText(t("dataProcessing.numeral1.paragraph1"))}
                {returnText(t("dataProcessing.numeral1.paragraph2"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    2. {t("dataProcessing.numeral2.title")}
                </h5>
                {returnTextWithNumber("2.1.", t("dataProcessing.numeral2.paragraph1"))}
                {returnText(t("dataProcessing.numeral2.paragraph2"))}
                {returnText(t("dataProcessing.numeral2.paragraph3"))}

                {returnTextWithNumber("2.2.", t("dataProcessing.numeral2.paragraph4"))}
                {returnText(t("dataProcessing.numeral2.paragraph5"))}
                {returnText(t("dataProcessing.numeral2.paragraph6"))}

                {returnTextWithNumber("2.3.", t("dataProcessing.numeral2.paragraph7"))}
                {returnText(t("dataProcessing.numeral2.paragraph8"))}
                <div className='w-full flex flex-col gap-2 pl-[15px]'>
                    {returnText(t("dataProcessing.numeral2.paragraph8a"))}
                    {returnText(t("dataProcessing.numeral2.paragraph8b"))}
                    {returnText(t("dataProcessing.numeral2.paragraph8c"))}
                    {returnText(t("dataProcessing.numeral2.paragraph8d"))}
                </div>

                {returnText(t("dataProcessing.numeral2.paragraph9"))}
                <div className='w-full flex flex-col gap-2 pl-[15px]'>
                    {returnText(t("dataProcessing.numeral2.paragraph9a"))}
                    {returnText(t("dataProcessing.numeral2.paragraph9b"))}
                    {returnText(t("dataProcessing.numeral2.paragraph9c"))}
                    {returnText(t("dataProcessing.numeral2.paragraph9d"))}
                    {returnText(t("dataProcessing.numeral2.paragraph9e"))}
                </div>
                {returnText(t("dataProcessing.numeral2.paragraph10"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    3. {t("dataProcessing.numeral3.title")}
                </h5>
                {returnText(t("dataProcessing.numeral3.paragraph1"))}
                {returnText(t("dataProcessing.numeral3.paragraph2"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    4. {t("dataProcessing.numeral4.title")}
                </h5>
                {returnText(t("dataProcessing.numeral4.paragraph1"))}
                {returnText(t("dataProcessing.numeral4.paragraph2"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    5. {t("dataProcessing.numeral5.title")}
                </h5>
                {returnText(t("dataProcessing.numeral5.paragraph1"))}
                {returnText(t("dataProcessing.numeral5.paragraph2"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    6. {t("dataProcessing.numeral6.title")}
                </h5>
                {returnText(t("dataProcessing.numeral6.paragraph1"))}
                {returnText(t("dataProcessing.numeral6.paragraph2"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    7. {t("dataProcessing.numeral7.title")}
                </h5>
                {returnText(t("dataProcessing.numeral7.paragraph1"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    8. {t("dataProcessing.numeral8.title")}
                </h5>
                {returnText(t("dataProcessing.numeral8.paragraph1"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    9. {t("dataProcessing.numeral9.title")}
                </h5>
                {returnText(t("dataProcessing.numeral9.paragraph1"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    10. {t("dataProcessing.numeral10.title")}
                </h5>
                {returnText(t("dataProcessing.numeral10.paragraph1"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    11. {t("dataProcessing.numeral11.title")}
                </h5>
                {returnText(t("dataProcessing.numeral11.paragraph1"))}
                {returnText(t("dataProcessing.numeral11.paragraph2"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    12. {t("dataProcessing.numeral12.title")}
                </h5>
                {returnText(t("dataProcessing.numeral12.paragraph1"))}
            </div>

            {/* manual data processing xervix */}

            <h3 className='w-full text-[18px] text-[#03314B] font-semibold flex justify-center mt-[20px]'>
                {t("manualDataProcessingXervix.title")}
            </h3>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    1. {t("manualDataProcessingXervix.numeral1.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral1.paragraph1"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    2. {t("manualDataProcessingXervix.numeral2.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral2.paragraph1"))}
                {returnText(t("manualDataProcessingXervix.numeral2.paragraph2"))}
                {returnText(t("manualDataProcessingXervix.numeral2.paragraph3"))}
                {returnText(t("manualDataProcessingXervix.numeral2.paragraph4"))}
                {returnText(t("manualDataProcessingXervix.numeral2.paragraph5"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    3. {t("manualDataProcessingXervix.numeral3.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral3.paragraph1"))}
                {returnText(t("manualDataProcessingXervix.numeral3.paragraph2"))}
                {returnText(t("manualDataProcessingXervix.numeral3.paragraph3"))}
                {returnText(t("manualDataProcessingXervix.numeral3.paragraph4"))}
                {returnText(t("manualDataProcessingXervix.numeral3.paragraph5"))}
                {returnText(t("manualDataProcessingXervix.numeral3.paragraph6"))}
                {returnText(t("manualDataProcessingXervix.numeral3.paragraph7"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    4. {t("manualDataProcessingXervix.numeral4.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral4.paragraph1"))}
                {returnText(t("manualDataProcessingXervix.numeral4.paragraph2"))}
                {returnText(t("manualDataProcessingXervix.numeral4.paragraph3"))}
                {returnText(t("manualDataProcessingXervix.numeral4.paragraph4"))}
                {returnText(t("manualDataProcessingXervix.numeral4.paragraph5"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    5. {t("manualDataProcessingXervix.numeral5.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral5.paragraph1"))}
                {returnText(t("manualDataProcessingXervix.numeral5.paragraph2"))}
                {returnText(t("manualDataProcessingXervix.numeral5.paragraph3"))}
                {returnText(t("manualDataProcessingXervix.numeral5.paragraph4"))}
                {returnText(t("manualDataProcessingXervix.numeral5.paragraph5"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    6. {t("manualDataProcessingXervix.numeral6.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral6.paragraph1"))}
                {returnText(t("manualDataProcessingXervix.numeral6.paragraph2"))}
                {returnText(t("manualDataProcessingXervix.numeral6.paragraph3"))}
                {returnText(t("manualDataProcessingXervix.numeral6.paragraph4"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    7. {t("manualDataProcessingXervix.numeral7.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral7.paragraph1"))}
                {returnText(t("manualDataProcessingXervix.numeral7.paragraph2"))}
                {returnText(t("manualDataProcessingXervix.numeral7.paragraph3"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    8. {t("manualDataProcessingXervix.numeral8.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral8.paragraph1"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    9. {t("manualDataProcessingXervix.numeral9.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral9.paragraph1"))}
                {returnText(t("manualDataProcessingXervix.numeral9.paragraph2"))}
                <h5 className={classSubtitle}>
                    {t("manualDataProcessingXervix.numeral9.paragraph3")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral9.paragraph3a"))}
                {returnText(t("manualDataProcessingXervix.numeral9.paragraph3b"))}
                {returnText(t("manualDataProcessingXervix.numeral9.paragraph3c"))}
                {returnText(t("manualDataProcessingXervix.numeral9.paragraph3d"))}
                {returnText(t("manualDataProcessingXervix.numeral9.paragraph3e"))}
                {returnText(t("manualDataProcessingXervix.numeral9.paragraph4"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    10. {t("manualDataProcessingXervix.numeral10.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.numeral10.paragraph1"))}
            </div>

            <div className='w-full flex flex-col gap-[20px]'>
                <h5 className={classSubtitle}>
                    {t("manualDataProcessingXervix.contact.title")}
                </h5>
                {returnText(t("manualDataProcessingXervix.contact.paragraph1"))}
                {returnText(t("manualDataProcessingXervix.contact.email"))}
                {returnText(t("manualDataProcessingXervix.contact.web"))}
            </div>
        </div >
    )
}

export default DataProcessing